import { JoinTelehealthRoomResponse, GetZoomJoinUrlParams } from "../../../types/generated/models";
import { useGetQuery } from "../../../hooks/useClientPortalQuery";

export function useTelehealthZoomUrls(clientPortalGuid: string, roomParams: GetZoomJoinUrlParams) {
    const { roomId, isMobile } = roomParams;

    const { data, isLoading, refetch } = useGetQuery<JoinTelehealthRoomResponse>({
        url: `/api/v1/${clientPortalGuid}/Telehealth/GetZoomJoinUrl?roomId=${encodeURIComponent(roomId)}&isMobile=${isMobile}`,
        options: { enabled: false },
    });

    return {
        data: data ?? {},
        isLoading: isLoading,
        refetch,
    };
}
